import React, { createRef, useEffect, useState } from "react";
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../../api/apiUtil";
import Table from "../../../components/Table/Table";
import getToken, { redirectToLogin } from "../../getToken";
import authStore from "../../../store/authStore";
import api from "../../../api/api";
import "./memberList.css";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import calenderIcon from "../../../images/icons/calendar.png";
import * as XLSX from "xlsx";
import excelIcon from "../../../images/icons/download.png";
import { message } from "antd";

const MemberReport = () => {
  const refMemberReportTable = createRef();
  const [keyword, setKeyword] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  const [addList, setaddList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const brandId = authStore((state) => state.auth?.brandId);

  const [paramReport, setParamReport] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
    startDate: format(startDate, "yyyy-MM-dd"),
    endDate: format(endDate, "yyyy-MM-dd"),
  });

  const retrieveaddList = async (value = paramReport) => {
    var request = {
      ...value,
      keyword: value.keyword || "",
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd")
    };

    api.post("Admin/GetMemberReport", request, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            message.warning(response.data.message);
            redirectToLogin();
          } else if (response.data.code === 200) {
            setaddList({
              isLoading: false,
              limit: 10,
              data: response.data.data.data || [],
              total: response.data.data.totalRecords,
              page: response.data.data.paging,
            });
            setExcelData(response.data.data.data);
          } else {
            setaddList({
              data: [],
              total: 0,
              page: 0,
              limit: 0,
              isLoading: false,
            });
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });
  };

  useEffect(() => {
    retrieveaddList({
      ...paramReport,
      keyword
    });
  }, [paramReport.currentPage, startDate, endDate]);

  const handleDateRangeChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setStartDate(startDate);
    setEndDate(endDate);
    setDateRange({ startDate, endDate });
    retrieveaddList();
  };

  const handleInputClick = () => {
    setShowDatePicker((prevState) => !prevState);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".date-input-container")) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const exportToExcel = async () => {
    try {
      const request = {
        ...paramReport,
        keyword,
        currentPage: 1,
        rowLimit: 100000,
        startDate: format(startDate, "yyyy-MM-dd"),
        endDate: format(endDate, "yyyy-MM-dd"),
      };

      const result = await api.post(
        "Admin/GetMemberReport",
        request,
        getToken()
      );

      apiUtil.parseResult(result, (response) => {
        const allData = response.data.data.data || [];

        const excelDataFormatted = allData.map((row, index) => ({
          No: index + 1,
          Name: row.name || "-",
          Marker: row.markerName || "-",
          Phone: row.phone || "-",
          Address: row.address || "-",
        }));

        const ws = XLSX.utils.json_to_sheet(excelDataFormatted);
        const wb = XLSX.utils.book_new();
        const fileName = "ကုန်သည် စာရင်း.xlsx";
        XLSX.utils.book_append_sheet(wb, ws, "ကုန်သည် စာရင်း");

        XLSX.writeFile(wb, fileName);
      });
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  return (
    <>
      <div className="Actions space_between">
        <h6 className="title_text mt-2">Member Report</h6>

        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* Export to Excel */}
          <div>
            <button className="export-button" onClick={exportToExcel}>
              <img src={excelIcon} className="icon" />
              Export to Excel
            </button>
          </div>

          {/* dateRangePicker */}
          <div className="date-input-container ">
            <input
              type="text"
              className="inputBox input-right-side_text "
              value={`${format(dateRange.startDate, "yyyy MMM dd")} - ${format(
                dateRange.endDate,
                "yyyy MMM dd"
              )}`}
              readOnly
              onClick={handleInputClick}
            />
            <img
              src={calenderIcon}
              className="iconDate"
              onClick={handleInputClick}
            />
            {showDatePicker && (
              <div className="input-dateRange">
                <DateRange
                  showDateDisplay={false}
                  ranges={[{ startDate, endDate, key: "selection" }]}
                  onChange={handleDateRangeChange}
                />
              </div>
            )}
          </div>
          <div>
            <CustomSearchBar
              value={keyword}
              setValue={setKeyword}
              onSearch={(value) => retrieveaddList({
                ...paramReport,
                keyword: value || "",
                currentPage: 1
              })}
            />
          </div>
        </div>
      </div>

      <div className="table_container member_report_table">
        <Table
          ref={refMemberReportTable}
          maxBodyHeight={addList.limit * 100}
          isLoading={addList.isLoading}
          grouping={addList.grouping}
          limit={addList.limit}
          page={addList.page}
          total={addList.total}
          data={addList.data}
          onPageChange={(page) => {
            setParamReport(prev => ({
              ...prev,
              currentPage: page,
            }));
          }}
          columns={[
            {
              title: "No",
              render: (row) => row.tableIndex + 1,
              width: "10px",
            },

            // name
            {
              title: "Name",
              render: (row) => {
                if (row.name == null || row.name == "") {
                  return "Unknown";
                }
                return row.name;
              },
              width: "80px",
            },

            // marker
            {
              title: "Marker",
              field: "markerName",
              width: "120px",
            },

            // phone
            {
              title: "Phone Number",
              field: "phoneNo",
              width: "120px",
            },

            // address
            {
              title: "Address",
              field: "address",
              width: "200px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default MemberReport;
